module.exports = __webpack_public_path__ + "static/darren-doodle-26566578f5ca38f6a953d639f045ade1.svg";